import { createContext } from "react";
import type { SnackbarProps } from "./Snackbar";

export type ShowNotificationAction = (props: Partial<SnackbarProps>) => void;

export const SnackbarContext = createContext<
  ShowNotificationAction | undefined
>(undefined);
